import translations from './translations'

translations.add('is', {
    yourBrowserDoesNotSupportIFrames: 'Vafrinn þinn styður ekki iframes.'
})
